<script lang="ts">
  import PreviewInfoModal from "@retailer/svelte/RetailerPreview/PreviewInfoModal.svelte";
  import { open as openPreviewModal } from "@retailer/svelte/stores/PreviewInfoModalStore";
  import CurrentUserStore from "@shared/svelte/Stores/CurrentUserStore";
  import type { Market } from "@shared/types/Market";
  import { HttpPromise } from "@shared/svelte/Modules/ApiService";

  let markets: Market[] = [];
  let selectedMarketId: number;

  let user: any = $CurrentUserStore;
  selectedMarketId = user.market.id;

  const loadMarkets = async () => {
    const options = {
      method: "GET",
      url: `/api/retailer/markets`,
      data: { market_id: selectedMarketId },
    };

    markets = await HttpPromise(options);
  };

  const updateMarket = async () => {
    const options = {
      method: "PUT",
      url: `/api/retailer/retailers/update_market`,
      data: { market_id: selectedMarketId },
    };

    let res = await HttpPromise(options);
    window.location.reload();
  };

  loadMarkets();

  const exitPreview = async () => {
    const options = {
      method: "POST",
      url: "/api/retailer/retailers/exit_supplier_preview",
    };

    await HttpPromise(options);
    window.location.reload();
  };

  openPreviewModal();

</script>

<PreviewInfoModal salesRepPreview={false} />
<div class="fizz-styles supplier-preview-header">
  <div
    class="fizz-flex-row fizz-space-between fizz-inset-squish-16"
    style="background-color: #595959"
  >
    <div>
      <div class="fizz-flex-row-4">
        <label for="supplier_preview_market" class="fizz-hide-on-small fizz-text-inverse">
          You are previewing Provi as:
        </label>

        <!-- svelte-ignore a11y-no-onchange -->
        <select
          class="fizz-select fizz-input-small"
          name="supplier_preview_market"
          bind:value={selectedMarketId}
          on:change={() => updateMarket()}
        >
          {#each markets as market}
            <option value={market.id}>{market.state} - {market.name}</option>
          {/each}
        </select>
      </div>
    </div>
    <div>
      <button class="fizz-button fizz-button-small" on:click={() => exitPreview()}
        >Exit Retailer Preview</button
      >
    </div>
  </div>
</div>
